module.exports = __webpack_public_path__ + "d8a1c42cca1a2003565bd1e4ee54244b.png";